import { isBoardCardOrder } from './boardOrdersListView';

/**
 * Listagem card → detalhe full via APIs existentes (lookup-for-modal + /api/board/orders/...).
 */

export function needsBoardOrderFullLookup(order) {
  if (!order || typeof order !== 'object') return true;
  if (isBoardCardOrder(order)) return true;
  const os = order.TB02115_OS ?? order.tb02115_os;
  return !String(os ?? '').trim();
}

/**
 * Junta snapshot de listagem + full do lookup, preservando contexto do Board.
 * Remove _boardView do payload do modal.
 */
export function mergeBoardOrderDetailPayload({ cacheOrder, fullOrder, ctx = {} } = {}) {
  const source = fullOrder && typeof fullOrder === 'object' ? fullOrder : cacheOrder;
  if (!source || typeof source !== 'object') return null;

  const { _boardView, ...rest } = source;
  const cache = cacheOrder && typeof cacheOrder === 'object' ? cacheOrder : {};

  const detailModalBoardTechnician =
    ctx.detailModalBoardTechnician != null
      ? ctx.detailModalBoardTechnician
      : cache.detailModalBoardTechnician != null
        ? cache.detailModalBoardTechnician
        : rest.detailModalBoardTechnician != null
          ? rest.detailModalBoardTechnician
          : null;

  let forecastGroup;
  if (ctx.source === 'open') {
    forecastGroup = 'Em Aberto';
  } else if (ctx.forecastGroup != null && String(ctx.forecastGroup).trim() !== '') {
    forecastGroup = ctx.forecastGroup;
  } else if (cache.forecastGroup != null && String(cache.forecastGroup).trim() !== '') {
    forecastGroup = cache.forecastGroup;
  } else if (ctx.groupName != null && String(ctx.groupName).trim() !== '') {
    forecastGroup = ctx.groupName;
  } else {
    forecastGroup = rest.forecastGroup || 'Em Aberto';
  }

  const fromFuturaRetornoLiberado =
    ctx.fromFuturaRetornoLiberado === true ||
    ctx.futuraRetornoTab === 'liberado' ||
    cache.fromFuturaRetornoLiberado === true ||
    rest.fromFuturaRetornoLiberado === true;

  const isPreAtendimento =
    ctx.isPreAtendimento === true ||
    cache.isPreAtendimento === true ||
    rest.isPreAtendimento === true;

  return {
    ...rest,
    forecastGroup,
    detailModalBoardTechnician,
    fromFuturaRetornoLiberado: Boolean(fromFuturaRetornoLiberado),
    isPreAtendimento: Boolean(isPreAtendimento),
  };
}
